import Vue from 'vue'
import { Message } from '@meta-vue/element-ui'

Vue.directive('copy', {
  inserted(el, binding) {
    init(binding.value, el)
  }
})

function init(value, el) {
  el.addEventListener('click', () => {
    copyText(value)
  })
}

function copyText(value) {
  const createInput = html => {
    const inputEl = document.createElement('input')
    inputEl.setAttribute('type', 'input')
    inputEl.value = html
    return inputEl
  }
  const inputEl = createInput(value)
  document.body.appendChild(inputEl)
  inputEl.select()
  document.execCommand('copy')
  document.body.removeChild(inputEl)
  Message.success('复制成功')
}
